import { render, staticRenderFns } from "./scope98.vue?vue&type=template&id=2ba68a38&scoped=true"
import script from "./scope98.vue?vue&type=script&lang=js"
export * from "./scope98.vue?vue&type=script&lang=js"
import style0 from "./scope98.vue?vue&type=style&index=0&id=2ba68a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba68a38",
  null
  
)

export default component.exports